/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { InlineObject } from '../model/models';
import { InlineObject1 } from '../model/models';
import { TourRequest } from '../model/models';
import { TourResource } from '../model/models';
import { TourStatusRequest } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface TourServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create a tour
     * 
     * @param tourRequest 
     */
    createTour(tourRequest: TourRequest, extraHttpRequestParams?: any): Observable<TourResource>;

    /**
     * Delete tour
     * 
     * @param tour The tour ID
     */
    deleteTour(tour: number, extraHttpRequestParams?: any): Observable<Array<any>>;

    /**
     * Show pdf
     * 
     * @param tour The tour ID
     */
    getPublicTourPdf(tour: number, extraHttpRequestParams?: any): Observable<object>;

    /**
     * Show tour
     * 
     * @param tour The tour ID
     */
    getTour(tour: number, extraHttpRequestParams?: any): Observable<TourResource>;

    /**
     * Show tour PDF
     * 
     * @param tour The tour ID
     */
    getTourPdf(tour: number, extraHttpRequestParams?: any): Observable<object>;

    /**
     * List tours
     * Filter by &#x60;type&#x60;, &#x60;status&#x60;, &#x60;userId&#x60;, &#x60;externalUserId&#x60;. Example &#x60;/tours?filter[type]&#x3D;1&#x60;
     * @param perPage 
     * @param page 
     */
    getTours(perPage?: string, page?: string, extraHttpRequestParams?: any): Observable<Array<TourResource>>;

    /**
     * Get user tours
     * 
     * @param userId 
     */
    getUserTours(userId?: string, extraHttpRequestParams?: any): Observable<Array<TourResource>>;

    /**
     * Update tour
     * 
     * @param tour The tour ID
     * @param tourRequest 
     */
    updateTour(tour: number, tourRequest: TourRequest, extraHttpRequestParams?: any): Observable<TourResource>;

    /**
     * Update status
     * 
     * @param tour The tour ID
     * @param tourStatusRequest 
     */
    updateTourStatus(tour: number, tourStatusRequest: TourStatusRequest, extraHttpRequestParams?: any): Observable<TourResource>;

}
